import _objectSpread from "/var/jenkins_home/workspace/ug-quartz-client-prod/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { searchAlarmUsers, fetchAlarmUsers, saveAlarmUser, deleteAlarmUser, deleteMultiAlarmUsers } from '@api/u8.api.alarm.user';
export default {
  data: function data() {
    return {
      data: [],
      gameData: [],
      loading: false,
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      adminType: 0,
      dialogFormVisible: false,
      form: {
        id: 0,
        name: '',
        phoneNum: '',
        email: '',
        dingding: ''
      },
      formSearch: {
        name: '',
        phoneNum: '',
        email: ''
      },
      rules: {
        name: [{
          required: true,
          message: '请输入姓名',
          trigger: 'blur'
        }]
      },
      dialogWidth: '50%',
      formLabelWidth: '120px',
      dialogTitle: '添加告警人',
      currSelectedRows: [],
      isFromEdit: false,
      filterGame: function filterGame(query, item) {
        return item.label.indexOf(query) > -1;
      }
    };
  },
  components: {},
  mounted: function mounted() {
    this.dialogWidth = this.$ajustDialogWidth();
    this.fetchData(true);
  },
  methods: {
    getPageItemNum: function getPageItemNum() {
      //获取当前表格页中有多少条记录
      var totalPageNum = Math.ceil(this.pagination.total / this.pagination.pageSize);

      if (this.pagination.currentPage == totalPageNum) {
        //最后一页
        return this.pagination.total % this.pagination.pageSize;
      }

      return this.pagination.pageSize;
    },
    onSearchSubmit: function onSearchSubmit() {
      //查询框按钮点击，或者查询条件文本输入触发查询
      this.fetchData(true);
    },
    onSearchReset: function onSearchReset() {
      //查询重置表单按钮点击，重置表单
      // this.formSearch.adminRoleID = ''
      this.$refs['formSearch'].resetFields();
      this.fetchData(true);
    },
    handleSizeChange: function handleSizeChange(currPageSize) {
      this.pagination.pageSize = currPageSize;
      this.fetchData(true);
    },
    paginationCurrentChange: function paginationCurrentChange(currentPage) {
      //分页事件
      this.pagination.currentPage = currentPage;
      this.fetchData(false);
    },
    handleSelectionChange: function handleSelectionChange(selection) {
      //多选事件
      this.currSelectedRows = selection;
    },
    fetchData: function fetchData(resetPage) {
      var _this = this;

      //从服务器端拉取数据，resetPage为true，说明重置分页到第一页；resetPage为false，停留在当前页
      this.loading = true;

      if (resetPage) {
        this.pagination.currentPage = 1;
      }

      searchAlarmUsers(_objectSpread(_objectSpread({}, this.pagination), this.formSearch)).then(function (res) {
        _this.data = res.records;
        _this.pagination.total = Number(res.total);
        _this.loading = false;
      }).catch(function (err) {
        console.log('err', err);
        _this.loading = false;
      });
    },
    addRow: function addRow() {
      //添加一条新记录
      this.isFromEdit = false;
      this.dialogTitle = "添加告警人";

      if (this.$refs['form']) {
        this.$refs['form'].resetFields();
        this.$refs['form'].clearValidate();
      }

      Object.assign(this.form, this.$options.data().form);
      this.dialogFormVisible = true;
    },
    editRow: function editRow(index, row) {
      //编辑当前记录
      this.isFromEdit = true;
      this.dialogTitle = "编辑告警人";

      if (this.$refs['form']) {
        this.$refs['form'].clearValidate();
      }

      this.dialogFormVisible = true;
      this.form = Object.assign({}, row);
    },
    deleteRow: function deleteRow(index, row) {
      var _this2 = this;

      //删除当前记录
      this.$confirm('确定要删除该记录吗', '删除确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        customClass: 'u8-style-delete'
      }).then(function () {
        deleteAlarmUser({
          "id": row.id
        }).then(function (res) {
          _this2.$message({
            type: 'success',
            message: '删除成功'
          });

          if (_this2.getPageItemNum() <= 1) {
            _this2.fetchData(true);
          } else {
            _this2.fetchData(false);
          }
        }).catch(function (err) {
          console.log("err", err);
        });
      }).catch(function () {
        _this2.$message({
          type: 'warning',
          message: '取消删除'
        });
      });
    },
    deleteRows: function deleteRows() {
      var _this3 = this;

      //删除选中的所有记录
      if (this.currSelectedRows.length == 0) {
        this.$message({
          message: '请选择要删除的记录',
          type: 'warning'
        });
        return;
      }

      this.$confirm('确定要删除选中的所有记录吗', '删除确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        customClass: 'u8-style-delete'
      }).then(function () {
        var ids = _this3.currSelectedRows.map(function (item) {
          return item.id;
        }).join(',');

        deleteMultiAlarmUsers({
          "ids": ids
        }).then(function (res) {
          _this3.$message({
            type: 'success',
            message: '删除成功'
          });

          if (_this3.getPageItemNum() <= _this3.currSelectedRows.length) {
            _this3.fetchData(true);
          } else {
            _this3.fetchData(false);
          }
        }).catch(function (err) {
          console.log('err', err);
        });
      }).catch(function () {
        _this3.$message({
          type: 'warning',
          message: '取消删除'
        });
      });
    },
    submitForm: function submitForm(formName) {
      var _this4 = this;

      //添加或者编辑表单提交
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          saveAlarmUser(_objectSpread({}, _this4.form)).then(function (res) {
            _this4.dialogFormVisible = false;

            _this4.$message({
              message: '操作成功',
              type: 'success'
            });

            if (_this4.isFromEdit) {
              _this4.fetchData(false);
            } else {
              _this4.fetchData(true);
            }
          }).catch(function (err) {
            console.log('err', err);
          });
        } else {
          return false;
        }
      });
    },
    resetForm: function resetForm(formName) {
      //添加或者编辑表单，清理表单数据
      this.dialogFormVisible = false;

      if (this.$refs[formName]) {
        this.$refs[formName].resetFields();
        this.$refs[formName].clearValidate();
      } else {
        console.log("the form is not exists." + formName);
      }
    }
  }
};